<template>
  <div :aria-hidden="!isMobile" class="mt-16 md:hidden">
    <div class="flex justify-between align-top">
      <ContainerProductTitles />
      <div class="text-static-default-hi mb-8 flex flex-row justify-end">
        <ContainerFavoritesToggle
          class="bg-static-default-low rounded-full"
          is-rounded
        />
      </div>
    </div>

    <ContainerRatingInfo class="mb-8" />

    <div class="mt-16 flex flex-row items-center">
      <div class="grow">
        <ContainerPrice />
      </div>

      <ContainerAddToCart
        data-id="product-page-buy-button-mobile"
        data-qa="product-page-buy-button-mobile"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useClientOnlyComputedBreakpoint } from '@backmarket/utils/composables/useClientOnlyComputedBreakpoint'
import { Breakpoint } from '@backmarket/utils/dom/getCurrentBreakpoint'

import ContainerAddToCart from '~/scopes/product-core/components/containers/ContainerAddToCart/ContainerAddToCart.vue'
import ContainerPrice from '~/scopes/product-core/components/containers/ContainerPrice/ContainerPrice.vue'
import ContainerFavoritesToggle from '~/scopes/product-core/components/containers/ContainerProductSummary/components/ContainerFavoritesToggle/ContainerFavoritesToggle.vue'
import ContainerRatingInfo from '~/scopes/product-core/components/containers/ContainerProductSummary/components/ContainerRatingInfo/ContainerRatingInfo.vue'
import ContainerProductTitles from '~/scopes/product-core/components/containers/ContainerProductTitles/ContainerProductTitles.vue'

// @FIXME: potential hydration mismatch caused by client-only breakpoint detection
const breakpoint = useClientOnlyComputedBreakpoint()
const isMobile = computed(() => breakpoint.value < Breakpoint.MD)
</script>
